import { shutdown } from '@intercom/messenger-js-sdk';
import { ITEMS } from 'consts/localStorage';
import { PATHS } from 'consts/paths';
import { removeCookie } from 'functions/cookies';
import { clearRecentGlobalSearches } from 'functions/recentGlobalSearchesFunctions';
import { COOKIES } from 'consts/cookies';

function logout(redirectUrl = PATHS.WEBSITE_LANDING_PATH) {
  shutdown();
  localStorage.removeItem(ITEMS.token);
  localStorage.removeItem('language');
  localStorage.removeItem('userToken');
  localStorage.removeItem('user_id');
  localStorage.removeItem('influencer');
  localStorage.removeItem('influencerImage');
  localStorage.removeItem('influencerName');
  localStorage.removeItem('preferred_currency');
  localStorage.removeItem('number_of_dashboard_loads');
  localStorage.removeItem(ITEMS.features);
  clearRecentGlobalSearches();

  removeCookie('extension_token', { path: '/' });
  removeCookie(COOKIES.logged, { path: '/' });
  removeCookie('features_up_to_date');
  window.postMessage('extension_logout', '*');
  window.location.href = redirectUrl;
}

export default logout;
